import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loader from '@/components/Loader/index.vue';

import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import { library } from '@fortawesome/fontawesome-svg-core';
library.add(faCircleNotch);

@Component({
	components: {
		Loader,
	},
})
export default class SwitchPortal extends Vue {
	@Prop() readonly on;
	@Prop() readonly name;

	@Prop({ default: 'Sim' }) readonly labelYes!: string;
	@Prop({ default: 'Não' }) readonly labelNo!: string;

	loading = false;
	isOn = false;

	created() {
		this.isOn = this.on || false;
	}

	yesWidth: number | null = null;
	noWidth: number | null = null;

	private toggle() {
		this.isOn = !this.isOn;
		this.$emit('change', this.name, this.isOn);
	}

	$refs!: {
		yes: HTMLFormElement;
		no: HTMLFormElement;
	}

	mounted() {
		Vue.nextTick().then(() => {
			Vue.nextTick().then(() => {
				this.calcWidths();
			});
		});
	}

	calcWidths() {
		this.yesWidth = this.$refs.yes.clientWidth;
		this.noWidth = this.$refs.no.clientWidth;
	}

	@Watch('on')
	onPropertyChanged(on: boolean) {
		this.isOn = on;
	}
}
